import { render, staticRenderFns } from "./destinatario.vue?vue&type=template&id=1df57da1&"
import script from "./destinatario.vue?vue&type=script&lang=js&"
export * from "./destinatario.vue?vue&type=script&lang=js&"
import style0 from "./destinatario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports